import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileUploadSessionService } from 'file-upload-session';
import { FileModel } from 'file-upload-session/lib/models/file-model';
import { Session } from 'file-upload-session/lib/models/session';
import { UploadedFile } from 'file-upload-session/lib/models/uploaded-file';
import { SignedUrl } from 'file-upload-session/lib/models/signed-url'
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/utils/app-settings';
import { CreateSession } from 'form-builder/lib/model/create-session';

@Injectable()
export class AnswerFileUploadService extends FileUploadSessionService {
  constructor(http: HttpClient) {
    super(http);
  }

  createSession(model: CreateSession): Observable<Session> {
    return this.http.post<Session>(`${AppSettings.apiUrl}attempt/${model.attempt_id}/fileuploadsession`, model);
  }
  getFilesForSession(sessionid: string): Observable<UploadedFile[]> {
    return this.http.get<UploadedFile[]>(`${AppSettings.apiUrl}fileuploadsession/${sessionid}`);
  }
  getUploadUrl(sessionid: string, file: FileModel): Observable<SignedUrl> {
    return this.http.post<SignedUrl>(`${AppSettings.apiUrl}fileuploadsession/${sessionid}/`, file);
  }
  complete(session_id: string, filekey: string): Observable<any> {
    return this.http.post<SignedUrl>(`${AppSettings.apiUrl}fileuploadsession/${session_id}/file/${filekey}/complete`, null);
  }
  delete(session_id: string, filekey: string): Observable<any> {
    return this.http.delete(`${AppSettings.apiUrl}fileuploadsession/${session_id}/file/${filekey}`);
  }
  getFileReadUrl(session_id: string, filekey: string): Observable<SignedUrl> {
    return this.http.post<SignedUrl>(`${AppSettings.apiUrl}fileuploadsession/${session_id}/file/${+filekey}/read`, {});
  }

}